import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { ApiResult } from 'src/app/shared/model/apiresult';
import { ITransactionLog } from 'src/app/modules/compliance/model/transactionlog';
import { TransactionLogService } from '../../services/transaction-log.service';

@Component({
    selector: 'transaction-log',
    templateUrl: './transaction-log.component.html'
})
export class TransactionLogComponent {
    displayedColumns: string[] = ['date', 'time', 'user','type', 'value', 'formervalue', 'term'];
    dataSource = new MatTableDataSource<ITransactionLog>();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    constructor(
        private _transactionlogservice: TransactionLogService
    ) {
    }

    ngOnInit() {
        //this.getTransactionLogById();
    }

    private getTransactionLogById() {
        this._transactionlogservice.getTransactionLogById('').subscribe((result: ApiResult<ITransactionLog[]>) => {
            if (result.validationErrors == null) {
                this.dataSource = new MatTableDataSource<ITransactionLog>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        }, error => console.error(error));
    }
}
